import jwtDecode from "jwt-decode";
export default (token) => jwtDecode(token);
